import { render, staticRenderFns } from "./addRecipient.vue?vue&type=template&id=522e3eb8&"
import script from "./addRecipient.vue?vue&type=script&lang=js&"
export * from "./addRecipient.vue?vue&type=script&lang=js&"
import style0 from "./addRecipient.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports